export default class User {
	constructor (user) {
		this.firstName = user.first_name
		this.lastName = user.last_name
		this.fullName = `${user.first_name} ${user.last_name}`
		this.role = user.role
	}
}
